<template>
    <div class="container">
        <span style="font-size: 20px;">收款明细</span>
        <div class="search-box">
            <!-- <el-radio-group fill="#f59a23" v-model="queryInfo.condition.queryType">
                <el-radio-button :label="1">营业日期</el-radio-button>
                <el-radio-button :label="2">支付(对账)日期</el-radio-button>
                <el-radio-button :label="3">支付时间</el-radio-button>
            </el-radio-group> -->
            <span style="font-size: 14px;">支付时间：</span>
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="dateTime" type="daterange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
            <el-button type="primary" icon="el-icon-search"
                style="margin-left: 20px;background-color: #f59a23;border: none;" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh" style="margin-left: 20px;" @click="reset">重置</el-button>
        </div>
        <el-table lement-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.3)" v-loading="loading" :data="tableData"
            style="width: 98%" border>
            <el-table-column prop="orderNumber" label="订单号" align="center" width="180"></el-table-column>
            <el-table-column prop="transNo" label="流水号" align="center" width="180"></el-table-column>
            <el-table-column prop="peopleCount" label="用餐人数" align="center" width="180"></el-table-column>
            <el-table-column prop="waiterName" label="服务员名称" align="center" width="180"></el-table-column>
            <el-table-column prop="marketerName" label="营销人员名称" align="center" width="180"></el-table-column>
            <el-table-column prop="orderDt" label="下单日期" align="center" width="180"></el-table-column>
            <el-table-column prop="finishDt" label="结账时间" align="center" width="180"></el-table-column>
            <el-table-column prop="beginTime" label="开台时间" align="center" width="180"></el-table-column>
            <el-table-column prop="beginUserName" label="开台人员名称" align="center" width="180"></el-table-column>
            <el-table-column prop="yuJieTime" label="预结时间" align="center" width="180"></el-table-column>
            <el-table-column prop="yuJieUserName" label="预结人员名称" align="center" width="180"></el-table-column>
            <el-table-column prop="isCheckOut" label="是否结账" align="center" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.isCheckOut == 1">是</span>
                    <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column prop="isZeroCheck" label="是否找零" align="center" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.isZeroCheck == 1">是</span>
                    <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column prop="sumPaid" label="订单金额" align="center" width="180"></el-table-column>

            <el-table-column prop="chargeFee" label="找零" align="center" width="180"></el-table-column>
            <el-table-column prop="tableTypeName" label="桌台类型名称" align="center" width="180"></el-table-column>
            <el-table-column prop="tableAreaName" label="桌台区域名称" align="center" width="180"></el-table-column>
            <el-table-column prop="tableName" label="桌台名称" align="center" width="180"></el-table-column>
            <el-table-column prop="memberName" label="会员名称" align="center" width="180"></el-table-column>
            <el-table-column prop="memberCardID" label="会员卡号" align="center" width="180"></el-table-column>
            <el-table-column prop="clientName" label="点单终端名称" align="center" width="180"></el-table-column>

            <el-table-column prop="checkOutTime" label="支付时间" align="center" width="180"></el-table-column>
            <el-table-column prop="checkOutUserName" label="结账人名称" align="center" width="180"></el-table-column>
            <el-table-column label="操作" align="center" width="180" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="goToDetail(scope.row.orderNumber)">订单详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.currPage" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
// 创建一个表示当前日期的 Date 对象
let currentDate = new Date();
let currentDate2 = new Date();

// 获取当前日期的天数
let currentDay = currentDate.getDate();

// 将日期减去一天
currentDate.setDate(currentDay - 1);
currentDate2.setDate(currentDay - 1);
export default {
    name: '',
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() >= today.getTime();
                }
            },
            dateTime: [currentDate2, currentDate],
            queryInfo: {
                currPage: 1,
                pageSize: 10,
                condition: {
                    queryType: 2
                }
            },
            tableData: [],
            loading: false,
            total: 0,
        };
    },
    mounted() {
        this.getData()
    },
    methods: {
        search() {
            this.getData()
        },
        reset() {
            this.dateTime = [currentDate2, currentDate]
            this.queryInfo.condition = { queryType: 2 }
            this.search()
        },
        // 获取当前页面
        handleCurrentChange(val) {
            this.queryInfo.currPage = val;
            this.getData();
        },
        // 修改页数大小
        handleSizeChange(val) {
            this.queryInfo.pageSize = val;
            this.getData();
        },
        async getData() {
            this.loading = true
            if (this.dateTime.length > 0) {
                this.queryInfo.condition.startTime = moment(this.dateTime[0]).format('YYYY-MM-DD') + ' 00:00:00'
                this.queryInfo.condition.endTime = moment(this.dateTime[1]).format('YYYY-MM-DD') + ' 23:59:59'
            }
            this.queryInfo.condition.merchantCode = localStorage.getItem('merchantCode')

            let res = await this.$http.post('/merchantOrderHistory/collectionDetails', this.queryInfo)
            if (res.data.code == 200) {
                this.total = res.data.data.count;
                this.queryInfo.currPage = res.data.data.currPage;
                this.tableData = res.data.data.data;
                this.loading = false
            }
        },
        goToDetail(orderNumber) {
            this.$router.push(
                '/statistics/details/order?orderNumber=' +
                orderNumber +
                '&currPage=' +
                this.queryInfo.currPage +
                '&orderType=payment'
            )
        },
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    padding: 20px;

    .search-box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 20px;

        span {
            font-size: 14px;
            margin-right: 10px;
        }
    }


}

/deep/ .el-radio-button__inner:hover {
    color: #f59a23;
}
</style>